/**
 * Constants related to resurrection and reactivation flows
 */

// Special coupon codes for resurrection flow
export const RESURRECTION_COUPON_CODES = {
  /**
   * Credits-based resurrection coupon (35% off 4 weeks)
   *
   * This code was updated from RES-35X6 (6 weeks) to RES-35X4 (4 weeks) as part
   * of a business strategy change to align with customer behavior analysis
   * showing optimal re-engagement with 4-week promotions instead of 6-week promotions.
   */
  CREDITS_35X4: 'RES-35X4'
}

// Common toast message timeouts
export const TOAST_TIMEOUT = {
  STANDARD: 5000
}

// Redirection routes
export const REDIRECT_ROUTES = {
  MEALS: '/meals',
  VALIDATE_CC: '/validate-cc'
}
